export default __webpack_public_path__ + "static/media/hand-right-front.5cc1bb5c.png";